import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../../api/client";

async function fetchConstantData(saleAreaId, projectId, department) {
  const searchOptions = {
    limit: 10000000,
    page: 1,
  };

  // if (projectId){
  //   searchOptions.status = 'OPEN';
  // }
  const searchQueryParams = new URLSearchParams(searchOptions).toString();
  let searchQueryParamsProject = new URLSearchParams(searchOptions).toString();
  let searchQueryEmployeeDepartment = new URLSearchParams(searchOptions).toString();

  let searchSaleBlockQueryParams = searchQueryParams;
  if (saleAreaId)
    searchSaleBlockQueryParams =
      searchQueryParams + "&" + new URLSearchParams({ saleAreaId }).toString();
  if (projectId)
    searchQueryParamsProject =
      searchQueryParams + "&" + new URLSearchParams({ projectId }).toString() ;
  if(department){
    searchQueryEmployeeDepartment =
      searchQueryParams + "&" + new URLSearchParams({ department }).toString() ;
  }
  // Fetch constant data concurrently
  const [
    jobPositionBussinesData,
    jobPositionSupportBussinesData,
    jobPositionAdminsData,
    jobTitleData,
    departmentData,
    saleBlockData,
    saleAreaData,
    branchData,
    supportDepartmentData,
    referralCodeData,
    businessCategoryData,
    guaranteeTypeData,
  ] = await Promise.all([
    clientAPI("get", "/jobPosition/allowType?type=1"),
    clientAPI("get", "/jobPosition/allowType?type=0"),
    clientAPI("get", "/jobPosition/allowType?type=2"),
    clientAPI("get", `/jobTitle?${searchQueryParams}`),
    clientAPI("get", `/department?${searchQueryParams}`),
    clientAPI("get", `/saleBlock?${searchSaleBlockQueryParams}`),
    clientAPI("get", `/saleArea?${searchQueryParams}`),
    clientAPI("get", `/branch?${searchQueryParams}`),
    clientAPI("get", `/supportDepartment?${searchQueryParams}`),
    clientAPI("get", `/referralCode?${searchQueryParams}`),
    clientAPI("get", `/businessCategory?${searchQueryParams}`),
    clientAPI("get", `/guaranteeType?${searchQueryParams}`),
  ]);

  // Index data by 'id' to improve lookup performance
  return {
    jobPositionBussines: jobPositionBussinesData?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    jobPositionSupportBussines: jobPositionSupportBussinesData?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    jobPositionAdminsData: jobPositionAdminsData?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    jobTitles: jobTitleData?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    departments: departmentData?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    saleBlocks: saleBlockData?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    saleAreas: saleAreaData?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    branches: branchData?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    supportDepartments: supportDepartmentData?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    referralCodes: referralCodeData?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    businessCategorys: businessCategoryData?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    guaranteeTypes: guaranteeTypeData?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
   
  };
}

export function useCategories(saleAreaId, projectId, department, shouldFetch) {
  // Fetch constant data once
  const {
    data: constantData,
    isLoading,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["categories13", saleAreaId, projectId, department],
    queryFn: () => fetchConstantData(saleAreaId, projectId, department),
    enabled: shouldFetch,
    refetchOnWindowFocus: false,
  });

  return {
    constantData,
    isLoading,
    isFetching,
    refetch,
  };
}
